import useTestId from '@ori/testid-generator';
import { Typography, styled, Link } from '@ori-ui/mui';
import type { FC, PropsWithChildren } from 'react';

import { useBasketLinkContext } from '~/contexts';

const Root = styled(Link)(({ theme }) => ({
  margin: theme.spacing(1),
  position: 'relative',
  display: 'block',
  whiteSpace: 'nowrap',
  height: 45,
  color: theme.palette.background.paper,
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  background: theme.palette.primary.main,
  textAlign: 'center',
  textTransform: 'uppercase',
  textDecoration: 'none',
  verticalAlign: 'middle',
  cursor: 'pointer',
  WebkitBoxSizing: 'border-box',
  boxSizing: 'border-box',
  maxWidth: '100%',
  fontWeight: 'bold',
  borderRadius: '999px',
  transition: 'box-shadow 0.15s, transform 0.15s',
  '&:hover': {
    boxShadow: '0 3px 8px 0 rgba(51, 51, 51, 0.1)',
    transform: 'scale(1.01)',
    color: theme.palette.background.paper,
  },
}));

const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  lineHeight: `${theme.spacing(8)}`,
}));

export const MainButton: FC<PropsWithChildren> = ({ children }) => {
  const basketLink = useBasketLinkContext();
  const { getTestId } = useTestId();

  return (
    <Root
      href={basketLink}
      data-testid={getTestId('button')}
    >
      <Label noWrap>{children}</Label>
    </Root>
  );
};
